import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { contact } from "../content/site";

const NAV = [
  { to: "/about", label: "About" },
  { to: "/events", label: "Events" },
  { to: "/contact", label: "Contact" },
];

export default function Layout() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <a className="skip" href="#main">
        Skip to content
      </a>
      <header className="site-header">
        <div className="wrap header-row">
          <Link to="/" className="brand" aria-label="Platform 18 home">
            <img src="/images/logo-white.png" alt="Platform Eighteen, a Partners Detroit initiative" width="204" height="87" />
          </Link>
          <button
            className="menu-toggle"
            aria-expanded={open}
            aria-controls="site-nav"
            onClick={() => setOpen((o) => !o)}
          >
            <span className="sr-only">Menu</span>
            <span aria-hidden="true" className={open ? "burger is-open" : "burger"} />
          </button>
          <nav id="site-nav" className={open ? "site-nav is-open" : "site-nav"} aria-label="Main">
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to}>
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main id="main">
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="wrap footer-grid">
          <div>
            <img src="/images/logo-white.png" alt="Platform Eighteen" width="160" height="68" />
            <p className="muted">A Partners Detroit initiative</p>
          </div>
          <div>
            <h2 className="label">Visit</h2>
            <p>
              <a href={contact.mapsHref} target="_blank" rel="noopener noreferrer">
                {contact.street}
                <br />
                {contact.city}
              </a>
            </p>
          </div>
          <div>
            <h2 className="label">Say hi</h2>
            <p>
              <a href={contact.phoneHref}>{contact.phone}</a>
              <br />
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
            </p>
          </div>
          <div>
            <h2 className="label">Follow</h2>
            <p>
              {contact.social.map((s, i) => (
                <span key={s.label}>
                  {i > 0 && <br />}
                  <a href={s.href} target="_blank" rel="noopener noreferrer">
                    {s.label}
                  </a>
                </span>
              ))}
            </p>
          </div>
        </div>
        <div className="wrap footer-base muted">
          <span>© {new Date().getFullYear()} Platform 18 · Partners Detroit</span>
          <nav className="footer-legal" aria-label="Legal">
            <Link to="/privacy">Privacy policy</Link>
            <Link to="/terms">Terms of service</Link>
          </nav>
        </div>
      </footer>
    </>
  );
}
